import { AppRoutes } from "@/routes/config";

export type TOrganizationTab = {
  value: string;
  label: string;
  path: string;
  /** Whether the tab screen is implemented. Unimplemented tabs only render their name. */
  implemented: boolean;
};

/**
 * 組織設定 tabs. Each tab has its own fixed path (not URL search params) so that
 * browser back/forward moves between tabs naturally and the unsaved-changes blocker
 * (which ignores query-param-only changes) fires correctly on tab switches.
 */
export const ORGANIZATION_TABS: TOrganizationTab[] = [
  { value: "business", label: "組織情報", path: AppRoutes.organizationBusiness, implemented: true },
  { value: "product", label: "商品設定", path: AppRoutes.organizationProduct, implemented: false },
  { value: "invoice", label: "請求設定", path: AppRoutes.organizationInvoice, implemented: true },
  { value: "template", label: "様式マスタ", path: AppRoutes.organizationTemplate, implemented: false },
  { value: "mail", label: "メール設定", path: AppRoutes.organizationMail, implemented: false },
  { value: "user", label: "ユーザー管理", path: AppRoutes.organizationUser, implemented: false },
  { value: "csv", label: "CSV出力設定", path: AppRoutes.organizationCsv, implemented: false },
  { value: "productLink", label: "プロダクト連携", path: AppRoutes.organizationProductLink, implemented: false },
];
